import React, { useState } from 'react'
import Modal from "react-modal";
import "./MarketingModal.scss"
import axios from "axios";
import { requestConstants } from "../../constants"
import { MarketingImage } from "../../components/image/Image"
import { useTranslation } from 'react-i18next';
import useWindowDimensions from "hooks/useWindowDimensions";

const MarketingModal = (props) => {
    const [isOpen, setIsOpen] = useState(false)
    const [response, setResponse] = useState(true)
    const { width } = useWindowDimensions();

    const { t } = useTranslation()
    React.useEffect(() => {
        const loadData = async () => {
            try {
                const resp = await axios.get(`${requestConstants["API_BASE_URL"]}/api/popup/active/${props.city}`)
                const { popup } = resp.data
                if (popup && popup.id) {
                    setResponse(popup)
                    setIsOpen(true)
                } else {
                    setIsOpen(false)
                }
            } catch (e) {
                setIsOpen(false)
            }
        }
        loadData()
    }, [props.city])

    React.useEffect(() => {
        let closeTimer = setTimeout(() => setIsOpen(false), (response?.closeTimeout ?? 15) * 1000);

        return () => {
            clearTimeout(closeTimer);
        };

    }, [response])

    if (!response) {
        return null
    }
    return (
        <Modal
            isOpen={isOpen}
            onRequestClose={() => setIsOpen(false)}
            className="marketingModal"
            ariaHideApp={false}
        >
            <span className="closeModalTextButton" onClick={() => setIsOpen(false)}>{t('previewRestaurantModal.component.anchor.close')}</span>
            {MarketingImage(response, width <= 576, () => setIsOpen(false))}
        </Modal>
    )
}

export default MarketingModal
